import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BuroLogo from '../../components/logo/BuroLogo';
import { contactDisclaimer,
  personalDataDisclaimer,
  fintechOperationsDisclaimer,
  governmentResponsibilityDisclaimer,
} from '../../constants/footer/mexico-footer-tyc-text';
import legalLinks from '../../constants/footer/mexico-legal-links';
import mexicoFooter from '../../constants/footer/mexico-footer';
import ContactInformationStack from '../../components/stacks/ContactInformationStack';
import SocialMediaStack from './components/SocialMediaStack';
import {
  containerStack,
  linksStack,
  linkTypography,
  logoStack,
  contactStack,
  legalStack,
  disclaimersStack,
  disclaimerTypography,
} from './styles/footer-mexico.styles';
import { STACK_START_COLUMN_DIRECTION } from '../../constants/mui-components';
import { isMexicoEnabled } from '../../helpers/featureFlags';

function FooterMexico() {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Stack sx={containerStack(theme)}>
      {/* Links legales */}
      <Stack className={STACK_START_COLUMN_DIRECTION} sx={linksStack}>
        {legalLinks.map((link) => (
          <Typography
            variant="small_2"
            href={link.href}
            rel="noopener noreferrer"
            target={link.href ? '_blank' : null}
            download={link.isDownload ? link.text : null}
            onClick={link.redirect ? () => { navigate(`${link.redirect}`); } : null}
            component="a"
            sx={linkTypography(theme)}
          >
            {link.text}
          </Typography>
        ))}
      </Stack>

      {/* Logo */}
      <Stack sx={logoStack}>
        <BuroLogo />
      </Stack>

      {/* Contacto */}
      <Stack sx={contactStack}>
        {mexicoFooter.contactInformation.map((contact) => (
          <ContactInformationStack
            key={contact.title}
            title={contact.title}
            description={contact.phone || contact.address}
            email={contact.email}
            navigateTo={contact.navigateTo}
          />
        ))}
        {isMexicoEnabled && <SocialMediaStack />}
      </Stack>

      {/* Aviso legal */}
      <Stack sx={legalStack}>
        <Typography
          variant="small_2"
          sx={disclaimerTypography(theme)}
        >
          {personalDataDisclaimer} {contactDisclaimer}
        </Typography>
      </Stack>

      {/* Disclaimers */}
      <Stack className={STACK_START_COLUMN_DIRECTION} sx={disclaimersStack}>
        <Typography variant="small_2" sx={disclaimerTypography(theme)}>
          {governmentResponsibilityDisclaimer} {fintechOperationsDisclaimer}
        </Typography>
      </Stack>
    </Stack>
  );
}

export default FooterMexico;
